import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { pipelineApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business パイプライン一覧取得フック。TanStack Queryでパイプライン設定一覧をキャッシュ管理
 * @graph-connects pipelineApi [calls] パイプラインAPIクライアント経由で一覧取得
 * @graph-connects queryKeys [calls] TanStack Queryキー生成
 */
export function usePipelineList() {
  return useQuery({
    queryKey: queryKeys.pipelines.list(),
    queryFn: pipelineApi.getConfigs,
  });
}

/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business パイプライン詳細取得フック。IDを指定して個別パイプライン設定を取得
 * @graph-connects pipelineApi [calls] パイプラインAPIクライアント経由で詳細取得
 * @graph-connects queryKeys [calls] TanStack Queryキー生成
 */
export function usePipelineDetail(id: string) {
  return useQuery({
    queryKey: queryKeys.pipelines.detail(id),
    queryFn: () => pipelineApi.getConfig(id),
    enabled: !!id,
  });
}

/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business パイプライン手動実行ミューテーション。spreadsheet_sync の読み取り行数の上書きも渡せる。実行後にパイプライン一覧キャッシュを無効化
 * @graph-connects pipelineApi [calls] パイプラインAPIクライアント経由で手動実行
 * @graph-connects queryKeys [calls] TanStack Queryキー生成・キャッシュ無効化
 */
export function useTriggerPipeline() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, limitFromEnd }: { id: string; limitFromEnd?: number }) =>
      pipelineApi.triggerPipeline(id, limitFromEnd),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.pipelines.all });
    },
  });
}
